import { object, string } from "yup";

export type CompanyStoreSetting = {
	authId: number;
	billingNoteForOwner: string | null;
	billingNoteForRentee: string | null;
	city: string | null;
	companyMasterId: number;
	masterAccount: boolean;
	name: string;
	otherAddress: string | null;
	phoneNumber: string | null;
	robotPaymentStoreCode?: string | null;
	settlementNoteForOwner: string | null;
	settlementNoteForRentee: string | null;
	state: string | null;
	zipcode: string | null;
};

export type AdminCompanyStoreSettingEdit = Pick<
	CompanyStoreSetting,
	"robotPaymentStoreCode"
>;
export type CompanyStoreSettingEdit = Omit<
	CompanyStoreSetting,
	"authId" | "companyMasterId" | "masterAccount" | "robotPaymentStoreCode"
>;

export const validationSchemaCompanyStoreSetting = object().shape({
	city: string().required("入力してください"),
	name: string().required("入力してください"),
	phoneNumber: string().required("入力してください"),
	state: string().required("入力してください"),
	zipcode: string()
		.required("入力してください")
		.test("len", "7桁で入力してください", (value: string | undefined | null) =>
			[7].includes((value ?? "").replace(/-/g, "").length)
		)
});
